var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04 0.46125C1.73 -0.15375 2.795 -0.15375 3.47 0.46125L7.91 4.45125L12.365 0.46125C13.04 -0.15375 14.105 -0.15375 14.795 0.46125C15.5 1.10625 15.5 2.21625 14.795 2.84625L10.46 6.74625L14.795 10.6462C15.515 11.2912 15.515 12.3862 14.795 13.0312C14.105 13.6462 13.04 13.6462 12.365 13.0312L7.91 9.04125L3.47 13.0312C2.795 13.6462 1.73 13.6462 1.04 13.0312C0.32 12.3862 0.32 11.2912 1.04 10.6462L5.375 6.74625L1.04 2.84625C0.32 2.20125 0.32 1.10625 1.04 0.46125Z",
    fill: "#FEFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.36c82f0a6b37764728bcf3ec89588819.svg";
export { ForwardRef as ReactComponent };